export const extractTextFromJson = (jsonString: string): string => {
  try {
    const jsonData = JSON.parse(jsonString);
    return jsonData.content
      .map((paragraph: any) =>
        paragraph.content.map((textNode: any) => textNode.text).join("")
      )
      .join("\n");
  } catch (error) {
    return "";
  }
};

export const getTextLength = (details: string): number => {
  try {
    console.log("details", typeof details);
    // 일반 문자열을 변환
    const parsedDetails =
      typeof details === "string"
        ? details.startsWith("{")
          ? JSON.parse(details)
          : {
              type: "doc",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      type: "text",
                      text: details,
                    },
                  ],
                },
              ],
            }
        : details;

    let textLength = 0;

    const traverseContent = (content: any) => {
      if (Array.isArray(content)) {
        content.forEach(traverseContent);
      } else if (content && typeof content === "object") {
        if (content.type === "text" && content.text) {
          textLength += content.text.length;
        }
        if (content.content) {
          traverseContent(content.content);
        }
      }
    };

    traverseContent(parsedDetails.content);
    return textLength;
  } catch (error) {
    return typeof details === "string" ? details.length : 0;
  }
};
